"use client";

import { createContext, useContext, useEffect, useState } from "react";
import { usePathname } from "next/navigation";

const RouteChangeContext = createContext();

export function RouteChangeProvider({ children }) {
  const [loading, setLoading] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    if (loading) {
      const timeout = setTimeout(() => setLoading(false), 300);
      return () => clearTimeout(timeout);
    }
  }, [pathname]);

  return (
    <RouteChangeContext.Provider value={{ loading, setLoading }}>
      {children}
    </RouteChangeContext.Provider>
  );
}

export function useRouteChange() {
  return useContext(RouteChangeContext);
}
